import { Component, EventEmitter, OnInit, Output, Input, SimpleChanges } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
@Component({
	selector: 'app-days-filter-r10',
	styleUrls: ['./days-filter-r10.component.css'],
	templateUrl: './days-filter-r10.component.html'
})
export class DaysFilterR10Component implements OnInit {
	@Input() daysButton: boolean = true;
	@Input() applyNodata: boolean = false;
	@Input() weeksButton: boolean = false;
	@Input() monthsButton: boolean = false;
	@Output() readonly buttonEventUpdate: EventEmitter<any> = new EventEmitter();
	public reloadSubscription;

	constructor() {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe(() => {
			this.updateButtonColor('daysButton', ['weeksButton', 'monthsButton']);
			this.changeGraphData('days');
		});
	}

	ngOnInit(): void {}

	changeGraphData(type: string): void {
		switch (type) {
			case 'days':
				this.updateButtonColor('daysButton', ['weeksButton', 'monthsButton']);
				this.buttonEventUpdate.emit(type);
				break;
			case 'weeks':
				this.updateButtonColor('weeksButton', ['daysButton', 'monthsButton']);
				this.buttonEventUpdate.emit(type);
				break;
			case 'months':
				this.updateButtonColor('monthsButton', ['weeksButton', 'daysButton']);
				this.buttonEventUpdate.emit(type);
				break;
			default:
				this.updateButtonColor('daysButton', ['weeksButton', 'monthsButton']);
				this.buttonEventUpdate.emit(type);
		}
	}

	updateButtonColor(enabledType: string, disabledTypes: string[]): void {
		this[`${enabledType}`] = true;
		this[`${disabledTypes[0]}`] = false;
		this[`${disabledTypes[1]}`] = false;
	}
}
